export function LoadingScreen({ message = 'Loading workspace...' }: { message?: string }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-ink-950 text-slate-200">
      <div className="space-y-4 text-center">
        <div className="mx-auto h-14 w-14 rounded-2xl border border-accent-400/40 bg-accent-500/15" />
        <p className="text-sm uppercase tracking-[0.22em] text-slate-400">{message}</p>
      </div>
    </div>
  );
}

